/**
 * Bilingual copy picker for the engine-visual components.
 *
 * These components carry a Hindi and an English string at nearly every leaf,
 * and writing each as an inline `isHi ? … : …` made every label a branch: the
 * linter counted 36 of them in one component and correctly refused it. Reading
 * the pair through one call keeps the copy exactly where it is rendered while
 * leaving the component's real branching visible.
 *
 * Argument order matches the ternary it replaces — Hindi first, then English —
 * so the swap is mechanical and diffable.
 */
export function localePicker(isHi: boolean) {
  return function pick<T>(hi: T, en: T): T {
    return isHi ? hi : en;
  };
}
